// Endpoint-hardening rollout (wildgrain-api config/canary.js + config/memberAuth.js).
//
// Every request to the API carries the member's Recharge session token as
// X-Member-Token so the API can verify who is calling. Nothing changes for the
// member until the API enforces it.
//
// A tester opts into the hardened behaviour in their own browser only:
//   localStorage.setItem('wg_hardening_canary', '<HARDENING_CANARY_SECRET>')
// That adds X-Hardening-Canary to API calls so the API applies its new gates to
// this browser while HARDENING_MODE=canary.
const CANARY_KEY = 'wg_hardening_canary';
const API_BASE = process.env.REACT_APP_BASE_API_URL || 'https://api.wildgrain.com';

export const getCanarySecret = () => {
  try {
    return localStorage.getItem(CANARY_KEY) || '';
  } catch {
    return '';
  }
};

export const readRechargeApiToken = () => {
  try {
    const session = JSON.parse(localStorage.getItem('rechargeSession') || 'null');
    return (session && session.apiToken) || '';
  } catch {
    return '';
  }
};

export const isWildgrainApiUrl = (url) =>
  typeof url === 'string' && (url.startsWith(API_BASE) || url.startsWith('https://api.wildgrain.com'));

// Headers to attach to every wildgrain-api request.
export const apiAuthHeaders = () => {
  const headers = {};
  const token = readRechargeApiToken();
  if (token) headers['X-Member-Token'] = token;
  const canary = getCanarySecret();
  if (canary) headers['X-Hardening-Canary'] = canary;
  return headers;
};
